// Copyright (c) Hamilton Manufacturing Corp.
import React, { useState } from 'react';
import styled from 'styled-components';
import { categorySort, duplicateSort, EU, generateId, plural } from '../../_common/api/utility';
import Cart from '../../_common/Cart';
import Button from '../../_common/form/Button';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import CheckoutCard from '../../_common/CheckoutCard';
import LogIn from '../LogIn';
import Page from '../pageLayout/Page';

const Item = styled.div`
    padding: 0.3em;
    overflow: hidden;
`
const Row = styled.div`
    display: flex;
    justify-content: space-between
`
const Empty = styled.div`
    text-decoration: underline;
    font-size: 0.8em;
`

const Checkout = ({ ...props }) => {
    const { state: {
        site_config,
        active_user,
        cart
    } } = useGlobalState();

    const categories = [...new Set(cart.filter(e => !e.isGift).map(e => e.productType))].sort(categorySort)

    const [items] = useState([...new Set(duplicateSort(cart, 'productId').map(e => e.productId))])

    return (
        <Page>
            <Title icon='cart'>Cart</Title>
            {
                cart.length ?
                    <>
                        <Row>
                            <div><b>Total:</b> {Cart.GetTotalPrice()}</div>
                            <Empty onClick={() => Cart.Empty()}>Empty Cart</Empty>
                        </Row>
                        {active_user.isLoggedIn ?
                            <Button onClick={() => Cart.CompletePurchase()}>Proceed to checkout ({cart.length} {plural(cart.length, 'item')})</Button> :
                            <LogIn>Log In to make a Purchase</LogIn>
                        }
                        {
                            cart.find(e => e.isGift) ?
                                <Item key={generateId()}>
                                    <Title>· Gifts</Title>
                                    {
                                        cart
                                            .filter(e => e.isGift)
                                            .map(e => <CheckoutCard item={e} key={generateId()} />)
                                    }
                                </Item> :
                                null
                        }
                        {
                            categories.map(e => {
                                return (
                                    <Item key={generateId()}>
                                        <Title>· {EU(e)}</Title>
                                        {
                                            items.map(id => {
                                                const item = cart.filter(e => !e.isGift).find(f => f.productId === id && f.productType === e);
                                                if (!item) return null;
                                                return <CheckoutCard item={item} key={generateId()} />
                                            })
                                        }
                                    </Item>
                                )
                            })
                        }
                    </> :
                    <>
                        <div>Subtotal {Cart.GetTotalPrice()}</div>
                        Nothing in your Cart
                    </>
            }
        </Page>
    );
}

export default Checkout; 